export const c_progress_stepper_m_horizontal_m_compact__step_connector_PaddingBottom = {
  "name": "--pf-c-progress-stepper--m-horizontal--m-compact__step-connector--PaddingBottom",
  "value": "0",
  "var": "var(--pf-c-progress-stepper--m-horizontal--m-compact__step-connector--PaddingBottom)"
};
export default c_progress_stepper_m_horizontal_m_compact__step_connector_PaddingBottom;